var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"none"}},[_c('canvas',{ref:"canvasBack"})])
}
var staticRenderFns = []

export { render, staticRenderFns }